<template>
  <i class="close-icon inline-block pointer"
     @click="$emit('click')">
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.6" d="M0.954027 17L0 16.046L7.54597 8.5L0 0.954027L0.954027 0L8.5 7.54597L16.046 0L17 0.954027L9.45403 8.5L17 16.046L16.046 17L8.5 9.45403L0.954027 17Z" fill="black"/>
    </svg>
  </i>
</template>

<script>
  export default {
    name: 'CloseIcon',
    cy: String
  }
</script>

<style lang="less">
  .close-icon {
    @media only screen and (min-width: 0) {

    }
  }
</style>
